import { CSS } from '@project44/manifest-ds';

const breakpoints = {
  sm: '@media(min-width: 980px)',
  md: '@media(min-width: 1280px)',
  lg: '@media(min-width: 1450px)',
};

export const layoutStyles: CSS = {
  py: '$large',
  px: '$large',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  [breakpoints.md]: {
    width: 'initial',
    alignContent: 'center',
    flexDirection: 'row',
  },
};

export const infoContainerStyles: CSS = {
  alignSelf: 'center',
  width: '100%',
  px: 0,
  py: 0,
  [breakpoints.md]: {
    alignSelf: 'stretch',
    width: 550,
    px: 0,
    py: '1.5em',
  },
};

export const infoStyles: CSS = {
  width: '100%',
  rowGap: '40px',
  border: '1px solid $palette-grey-800',
  background: 'rgba(11, 26, 41, 0.7)',
  borderRadius: 8,
  color: 'white',
  minWidth: 400,
  maxWidth: 720,
  m: 0,
  mx: 'auto',
  p: 20,
  [breakpoints.sm]: {
    p: 80,
  },
  [breakpoints.md]: {
    p: 40,
    mb: 0,
    ml: 0,
    mr: '-2em',
    minWidth: 500,
  },
  [breakpoints.lg]: {
    minWidth: 660,
  },
};

export const pageScreenStyles: CSS = {
  'img, video': {
    borderRadius: '14px',
    height: 'initial',
    width: '100%',
    ml: '0.5em',
    [breakpoints.lg]: {
      ml: '6em',
      width: 'calc(100% - 6em)',
    },
  },
  [breakpoints.md]: {
    display: 'flex',
  },
};

export const buttonContainerStyle: CSS = {
  flexDirection: 'column',
  width: '100%',
  '> button': {
    marginBottom: '$medium',
  },
  [breakpoints.sm]: {
    flexDirection: 'row',
  },
};

export const buttonStyle: CSS = {
  width: '100%',
  [breakpoints.sm]: {
    width: '48%',
  },
};
